<!--
 * @Description: 客户管理页面
 * @Author: mdb
 * @Date: 2022-07-04 10:22:27
 * @LastEditTime: 2022-09-29 15:55:34
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosCustomerManage"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="集团客户代码">
              <a-input v-model:value.trim="queryForm.cosCenterCode" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="集团客户名称">
              <a-input v-model:value.trim="queryForm.cosCenterName" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="所属品牌">
              <a-select v-model:value="queryForm.brand" :options="brandEnum" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="签约主体">
              <a-input
                v-model:value.trim="queryForm.cusContractSubject"
                :maxlength="200"
                allowClear
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="所属组织">
              <a-select v-model:value="queryForm.appId" :options="orgEnum" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="业务系统">
              <a-select v-model:value="queryForm.sys" :options="sysEnum" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="客户代码">
              <a-input v-model:value.trim="queryForm.customerCode" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="增值税登记号">
              <a-input v-model:value.trim="queryForm.addedValueNo" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="法人姓名">
              <a-input v-model:value.trim="queryForm.legalPerson" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="联系人">
              <a-input v-model:value.trim="queryForm.contactName" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="电话">
              <a-input v-model:value.trim="queryForm.contactMobile" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="E-mail">
              <a-input v-model:value.trim="queryForm.contactEmail" :maxlength="200" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="创建时间">
              <cos-range-picker
                v-model:startTime="queryForm.createTimeStart"
                v-model:endTime="queryForm.createTimeEnd"
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <a-button
              v-permission="'customer_detail_btn'"
              type="link"
              @click="goToDetailsList(record.masterCosCenterCode)"
              >客户明细</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { brandEnum, orgEnum, sysEnum } from '@/views/customer/commonEnum/dataConfig'
import { customerList, getListBySensitize } from '@/api/customer'
import type { CustomerManageParams, CustomerManageListItem } from '@/typings/api/customer'
import dayjs from 'dayjs'

const router = useRouter()
const tableRef = ref()
const queryForm = reactive<CustomerManageParams>({})
queryForm.createTimeStart = dayjs().subtract(30, 'day').format('YYYY/MM/DD 00:00:00')
queryForm.createTimeEnd = dayjs().format('YYYY/MM/DD 23:59:59')
const columns = computed(() => [
  { title: '集团客户代码', dataIndex: 'cosCenterCode' },
  { title: '集团客户名称', dataIndex: 'cosCenterName' },
  { title: '所属品牌', dataIndex: 'brand', dicData: brandEnum },
  { title: '签约主体', dataIndex: 'cusContractSubject' },
  { title: '所属组织', dataIndex: 'appId', dicData: orgEnum },
  { title: '业务系统', dataIndex: 'sys', dicData: sysEnum },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '客户代码', dataIndex: 'customerCode' },
  { title: '增值税登记号', dataIndex: 'addedValueNo' },
  { title: '法人姓名', dataIndex: 'legalPerson', cosType: 'mask' },
  { title: '国家/地区', dataIndex: 'countryName' },
  { title: '省/地区', dataIndex: 'provinceName' },
  { title: '城市', dataIndex: 'cityName' },
  { title: '地址', dataIndex: 'address' },
  { title: '联系人', dataIndex: 'contactName', cosType: 'mask' },
  { title: '电话', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: 'E-mail', dataIndex: 'contactEmail', cosType: 'mask' },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 100, fixed: 'right' }
])
const getList = (queryForm: CustomerManageParams, callBack: (res: any) => void) => {
  customerList(queryForm).then((res) => {
    if (res.data && res.data.items && res.data.items.length) {
      res.data.items.forEach((item: CustomerManageListItem) => {
        if (item.appId) {
          item.appId = (item.appId as string).split(',')
        }
      })
    }
    callBack(res)
  })
}
const showMask = (record: CustomerManageListItem, callBack: (res: any) => void) => {
  getListBySensitize({
    cosCenterCode: record.cosCenterCode
  }).then((res) => {
    callBack(res.data)
  })
}

// 新增编辑函数
const goToDetailsList = (masterCosCenterCode: string) => {
  // 清缓存
  localStorage.setItem('dc-cos-lbu-exclude-keep-alive', masterCosCenterCode)
  router.push({
    path: '/customer/customerAggregation',
    query: {
      masterCosCenterCode
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosCustomerManage' }
</script>

<style scoped></style>
